import { cn } from '@/lib/utils'
import type { ChangeSetStatus } from '@/api/workflowChangeSets'

const statusConfig: Record<ChangeSetStatus, { label: string; className: string }> = {
  Pending: { label: 'Review required', className: 'bg-warning text-warning-foreground border-warning-foreground' },
  Applied: { label: 'Applied', className: 'bg-success text-success-foreground border-success-foreground' },
  Superseded: { label: 'Superseded', className: 'bg-neutral text-neutral-foreground border-neutral-foreground' },
  Discarded: { label: 'Discarded', className: 'bg-danger text-danger-foreground border-danger-foreground' },
}

const fallbackClassName = 'bg-neutral text-neutral-foreground border-neutral-foreground'

export function ChangeSetStatusBadge({
  status,
  className,
  testId = 'change-set-status-badge',
}: Readonly<{ status: ChangeSetStatus; className?: string; testId?: string }>) {
  const config = statusConfig[status]
  return (
    <span
      data-testid={testId}
      className={cn(
        'inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold tracking-wide',
        config?.className ?? fallbackClassName,
        className,
      )}
    >
      {config?.label ?? status}
    </span>
  )
}
